let COUNT = 0;

export function genId() {
  COUNT = (COUNT + 1) % Number.MAX_SAFE_INTEGER;

  return String(COUNT);
}
